// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"Alert_messageContainer__BJner","callToActionChildren":"Alert_callToActionChildren__SaKwd","notice":"Alert_notice__aj_Wu"};